module.exports = __webpack_public_path__ + "images/afd9e90a666e6ab77b9694d5bccc52b7.png";